import { makeStyles, Theme } from '@material-ui/core';
import React from 'react';
import EditPencil from '../../components/EditPencil';
import ProfileCard from '../../components/ProfileCard';
import { useUser } from '../../contexts';
import { InvestorIntro, ImageProvider, Role } from '../../types/types';

interface InvestorIntroPanelProps {
  investorIntro: InvestorIntro
  profileImageProvider: ImageProvider
  handleEdit?: () => void
}

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    margin: theme.spacing(0),
    position: 'relative'
  }
}));

const InvestorIntroPanel: React.FC<InvestorIntroPanelProps> = ({
  investorIntro,
  profileImageProvider,
  handleEdit
}) => {
  const editable = handleEdit !== undefined;
  const styles = useStyles();
  const { userRole } = useUser();
  const hideContactInfo = !userRole || userRole === Role.Ent;
  return (
    <div className={styles.root}>
      {editable && <EditPencil onClick={handleEdit} style={{ top: 10, right: 10, position: 'absolute' }} />}
      <ProfileCard
        name={investorIntro.contactName}
        email={investorIntro.email}
        profileImageProvider={profileImageProvider}
        company={investorIntro.companyName}
        linkedIn={hideContactInfo ? undefined : investorIntro.linkedinProfile}
        summary={investorIntro.intro}
        hideContactInfo={hideContactInfo}
        usePlaceholders={editable}
      />
    </div>
  );
};


export default InvestorIntroPanel;
